import React, { useState } from "react";
import { MedicalReviewerFlow } from "../ReusableComp/NavBarLeft";
import NavigationBar from "../ReusableComp/NavigationBar";
import { Col, Container, Row, Stack, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import CryptoJS from 'crypto-js';
import {
  getSubjectDtls,
  getEventDetails,
  getReviewerComments,
  resetEventDetails,
  resetSubjectProfile,
  getAllWhoddClassification,
  getSubjProfDetails,
  getPmsNotifications,
  getAllWhoddClassificationNew,
} from "../../Redux/actions/actions";
import {
  EVENT_STATUS_WAITING_FOR_REVIEW,
  EVENT_STATUS_IN_PROGRESS,
  EVENT_STATUS_REVIEWED,
  EVENT_STATUS_SENT_BACK_FOR_REVIEW,
  base_url,
  SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT,
  SUBJECT_STATUS_ON_STUDY,
  SUBJECT_STATUS_OFF_STUDY,
  EVENT_CLASSIFICATION_AESI,
  EVENT_CLASSIFICATION_LEVEL_BRIGHTON,
  EVENT_CLASSIFICATION_GRADE_CTCAE,
  EVENT_CLASSIFICATION_OTHER,
  CRYPTO_SECRET_KEY,
  MEDICAL_REVIEWER,
  PRINCIPAL_INVESTIGATOR,
  QUALITY_REVIEWER,
} from "../../utilities";
import PopUpModal from "../ReusableComp/PopUpModal";

import axios from "../../axios-interceptor";
import moment from "moment";
import { PopUpAlert } from "../ReusableComp/PopUpModal";
import Loader from '../ReusableComp/Loader';
import { FaEye, FaDownload, FaTimes } from 'react-icons/fa';
import { formatDateNoTime } from "../ReusableComp/dateFormat";
import { useNavigate, useLocation } from "react-router";
import { Modal, Button } from 'react-bootstrap';
import { Tooltip } from "react-tooltip";
import { MeddraDetails, MedicationDetails } from "../Quality_Reviewer/ReviewList";
import PasswordModal from "../Quality_Reviewer/PasswordModal";


const MedicalReviewerReviewList = () => {
  const dispatch = useDispatch();
  const getEventFlag = useSelector((state) => state.getEventFlag);
  const mrSubjectList = useSelector((state) => state.mrSubjectList);
  const subjDetails = useSelector((state) => state.subjDtls);
  const subjectCounts = useSelector((state) => state.mrSubjectcounts);
  const reviewerComments = useSelector((state) => state.reviewerComments);
  const [currentPage, setCurrentPage] = useState(1);
  const aeSubject = useSelector((state) => state.getAeOfSubj);
  const eventDtls = useSelector((state) => state.eventDtls);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState("");
  let [loading_flag, Setloading_flag] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [flag, setFlag] = useState(false);
  const [asc,setAsC]=useState(false);
  const [desc,setDesc]=useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const subjectProfile = useSelector((state) => state.getSubProf);
  const medraList = useSelector((state) => (state.medraList));
  const whoddList = useSelector((state) => (state.whoddList));
  const [mrStudyId, setMrStudyId] = useState("");
  const [whoDDClassification, setWhoDDClassification] = useState();
  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalAlert, setModalAlert] = useState(false)
  const [medicationDetails, setMedicationDetails] = useState([
    {
      "searchTerm":"",
      "ATC": "",
      "Product": "",
      "current_idx":0,
      "whoDDEncode":true,
      "whoddArray":[]
    },
  ]);

  let extensions=""
  const [masterArray2, setMasterArray2] = useState([])

  useEffect(() => {
    Setloading_flag(true)
    if(location.state !== null && mrSubjectList !== null){
      handleSubjectData(location.state?.data);
      navigate({ state: null });
    }
    
    if (eventDtls?.action_taken_for_adverse_event_name !== "None") {
      setFlag(true);
    }
    else {
      setFlag(false)
    }
    if(mrSubjectList){
      setTimeout(() => {
        Setloading_flag(false)
      }, 600);
      if (selectedOption === 'serious_adverse_events') {
        setFilteredData(mrSubjectList.filter(i => i.serious_adverse_event_id !== null))
      } else if (selectedOption === 'adverse_events') {
        setFilteredData(mrSubjectList.filter(i => i.adverse_event_id !== null))
      } else if(selectedOption === 'subject_with_pending'){
        setFilteredData(mrSubjectList.filter(i => i.status === 0 || i.status===1))
      }else if (selectedOption === 'all_events' || selectedOption === "total_reviews") {
        setSelectedOption("all_events")
        setFilteredData(mrSubjectList)
      }else {
        setSelectedOption("all_events")
        setFilteredData(mrSubjectList)
      }

    }
     
    if(currentPage===2 && eventDtls){
      setLoading(false)
    }
    


  }, [dispatch, localStorage.pi_id,localStorage.study_id, mrSubjectList !== null,eventDtls]);


  useEffect(()=>{
    if(mrSubjectList){
      setFilteredData(mrSubjectList);
    }
  },[mrSubjectList])

  const JustBtwn = "d-flex justify-content-between";



  function getStudieId(id) {
    setMrStudyId(id);
  }

  function calculateBMI(weight, height) {
    if (isNaN(weight) || isNaN(height) || height === null) {
        return "0"; // Display "N/A" if either weight or height is not a number
    }
    const bmi = weight / ((height / 100) ** 2);

    return bmi.toFixed(1);
}
  const dateOfReport = aeSubject?.date_of_report;
  const lastDayActiveFollowUp = aeSubject?.last_day_active_follow_up;
  const stepperData = [];
  const date = new Date(dateOfReport);
  while (date <= new Date(lastDayActiveFollowUp)) {
    stepperData.push({
      day: `Day${stepperData.length + 1}`,
      dateOfevent: date.toISOString().split("T")[0],
    });
    date.setDate(date.getDate() + 1);
  }
  function exportToExcel() {

    let excelArray = [];
    filteredData.forEach((i) => {

      switch (i.status) {
        case EVENT_STATUS_WAITING_FOR_REVIEW:
          i.status = "Waiting for review";
          break;
        case EVENT_STATUS_IN_PROGRESS:
          i.status = "In progress";
          break;
        case EVENT_STATUS_REVIEWED:
          i.status = "Reviewed";
          break;
        case EVENT_STATUS_SENT_BACK_FOR_REVIEW:
          i.status = "Sent back for review";
          break;
        default:
          break;
      }

      let xl_object = {
        "Date of upload": moment(i.event_createdAt).format("DD-MMM-YYYY"),
        "Adverse Events": i.adverse_event_name,
        "Serious Adverse Criteria": i.serious_adverse_event_name,
        "Subject ID": i.subject_code,
        "Site Name": i.site_name,
        "Status": i.status,
      };
      excelArray.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = excelArray;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "MR_event reviewlist.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }

  const [open, setOpen] = React.useState(false);

  const dashboardCards = [
    {
      count: subjectCounts?.saesCount,
      image: "./images/icons/exclamatory.svg",
      desc: "Serious Adverse Events",
      bgcolor: "#D14141",
      id:"serious_adverse_events"
    },
    {
      count: subjectCounts?.aesCount,
      image: "./images/icons/smiley.svg",
      desc: "Adverse Events",
      bgcolor: "#EA9E4F",
      id:"adverse_events"
    },
    {
      count: subjectCounts?.pendingReviews,
      image: "./images/icons/pending approval.svg",
      desc: "Pending",
      bgcolor: "#EAEAEA",
      textColor: "#000000",
      id:"subject_with_pending"
    },
    {
      count: subjectCounts?.subjectsCount,
      image: "./images/icons/subjects_white.svg",
      desc: "Total Subjects",
      bgcolor: "#8DA2B5",
      textColor: "#000000",
      id:"all_events"
    },
  ];

  let status = subjDetails && `${subjDetails['SubjectDoses.status']}`
  const myArray = [
    {
      title: subjDetails && subjDetails['Study.study_name'],
      description: "Study",
    },
    {
      description: "Dose",
      title: subjDetails && `D${subjDetails['SubjectDoses.dose']}`,
    },
    {
      title: subjDetails && subjDetails['PrincipalInvestigator.name'],
      description: "Principal Investigator",
    },
    {
      id: 4, description: "Status", title:
       status == SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT ? 'On going adverse event' :
          status == SUBJECT_STATUS_ON_STUDY ? 'On study' :
           status == SUBJECT_STATUS_OFF_STUDY ? 'Concluded study' : ''
    }
  ];
  

  const handleStudyChange = () => {
    setFilteredData(null);
    setSearchText("");
  };

  const handleSearchData = (event) => {
    const searchText = event.target.value?.toLowerCase();
    setSearchText(searchText);
    const filteredData = mrSubjectList?.filter((item) => {
      
      const { subject_code, site_name } = item;

      const formattedSubjectCode = subject_code?.toLowerCase();
      const formattedSiteName = site_name ? site_name.toLowerCase() : ""


      return (
        formattedSubjectCode.includes(searchText) ||
        formattedSiteName.includes(searchText)
      );
    });
    setFilteredData(filteredData);
  };
  const [subjData, setSubjData] = useState([]);
  const [studyDropdwn, setStudyDropdwn] = useState(false);
  const [studyOption, setStudyOption] = useState();
  const [inputValue, setInputValue] = useState("");

  const [inputValue1, setInputValue1] = useState("");
  const [isDivOpen, setIsDivOpen] = useState(false);
  const [reviewedDtls, setReviewedDtls] = useState(false);
  const toggleDiv = () => {
    setIsDivOpen(!isDivOpen);
  };
  const [open1, setOpen1] = useState(false)

  const alreadyAttended = ()=>{
    setOpen1(false)
    window.location.reload()
      // alert("The event has already been attended to!")
      return;
  }
  const handleSubjectData = (data) => {
    
    setLoading(true)
    setCurrentPage(2);
    
    if (data.status === EVENT_STATUS_REVIEWED) {
      setReviewedDtls(true);
    }
    if (data.status === EVENT_STATUS_IN_PROGRESS ) {
      setReviewedDtls(false);
    }
    if((mrSubjectList?.find(item => (item.subject_id === data.subject_id) && (item.adverse_event_id === data.adverse_event_id)).status) === EVENT_STATUS_SENT_BACK_FOR_REVIEW){
      data = mrSubjectList?.find(item => (item.subject_id === data.subject_id) && (item.adverse_event_id === data.adverse_event_id))
      setOpen1(true)
      setLoading(false)
    }
    if((mrSubjectList?.find(item => (item.subject_id === data.subject_id) && (item.adverse_event_id === data.adverse_event_id)).status) === EVENT_STATUS_REVIEWED){
      data = mrSubjectList?.find(item => (item.subject_id === data.subject_id) && (item.adverse_event_id === data.adverse_event_id))
      
      setReviewedDtls(true);
    }
    setSubjData(data)
    dispatch(getSubjectDtls(data))
    dispatch(getEventDetails(data))
    dispatch(getAllWhoddClassification())
    dispatch(getSubjProfDetails({subject_id: data.subject_id,
    dose:data.dose}))
    dispatch(getReviewerComments({
      adverse_event_mapping_id: data?.adverse_event_id
    }))
    if (data.status === 0) {
      let each_marketing_head = {
        event_id: data.adverse_event_id,
      };
      axios
        .post(
          base_url + "medical-reviewer/update_event_status",
          each_marketing_head
        )
        .then((res) => {
           setFilteredData()
          setStudyDropdwn(true);
          setCurrentPage(2);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setStudyDropdwn(true);
      setCurrentPage(2);
    }
  };
  const [dictnryEntries, setDictnryEntries] = useState([])
  const [selectedMedraId, setSelectedMedraId] = useState("")
  const [medraSelected, setIsMedraSelected] = useState(false)
  const [meddraClassification, setMeddraClassification] = useState();
  const [medView, setMedView] = useState(true)

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [piQrRadioVal, setPiQrRadioVal] = useState()

  // useEffect(() => {
  //   if (subjData.status === EVENT_STATUS_REVIEWED && eventDtls !== undefined) {
  //     axios
  //       .post(
  //         base_url + "quality-reviewer/fetch_medical_dictionary_entries",
  //         { "adverse_event_mapping_id": eventDtls?.adverse_event_mapping_id }
  //       )
  //       .then((res) => {
  //         setDictnryEntries(res.data.body)
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });


  //   }
  // }, [eventDtls?.adverse_event_mapping_id, mrStudyId])

  const getRoleCode = (data) => { };
  const [medraClassBlock, setMedraClassBlock] = useState({
    "llt": "",
    "pt": "",
    "hlt": "",
    "hlgt": "",
    "soc": ""
  })

  const [whoddBlock, setWhoddBlock] = useState({
    "atccode": "",
    "productcode": ""
  })

  function handleMedraClass(e) {
    const { name, value } = e.target;

    setMedraClassBlock((prev => ({
      ...prev,
      [name]: value,
    })))
  }
  const handleCheckboxChange2 = (selectedCheckbox, index) => {
    let updatedData = [...meddraDetails]
    updatedData.map(i => {
      if(i.current_idx === index){
        i.checkedMeddra = selectedCheckbox.meddra_mdhier_master_id
      }
    })
    masterArray2.map(i => {
      if(i.index === index){
        i.meddra_llt_master_id = selectedCheckbox.meddra_llt_master_id
        i.meddra_mdhier_master_id = selectedCheckbox.meddra_mdhier_master_id
      }
    })
    setMeddraDetails(updatedData)
    // setIsBtn(true)
  };
 

  const [reviewerComment, setReviewerComment] = useState('')
  const handleReviewerComments = (e) => {
    let val = e.target.value;
    let value = val.trim()
    setReviewerComment(value || '')
  };
  const cmtbtnStat = reviewerComment !== ''
  let rejectObj = {
    "adverse_event_mapping_id": eventDtls?.adverse_event_mapping_id,
    "reviewer_id": localStorage.mr_id,
    "user_persona": MEDICAL_REVIEWER,
    "comment": reviewerComment,
    "created_by": localStorage.login_user_name,
    "sent_back_to": piQrRadioVal,
  }
  function sentBack() {

    if (eventDtls) {
      axios
        .post(base_url + "comments/add_comment", rejectObj)
        .then((res) => {
          setLoading(false)
          setPwdModalShow(false)
          window.location.reload();

        })
    }
  }
  const [alertMessage, setAlrtMessage] = useState('')
  const [sendBackConfirmation, setSendBackConfirmation] = useState(false)
  const [btnId, setBtnId] = useState('')
  const [pwdModalShow, setPwdModalShow] =useState(false)
  const [enteredPassword, setEnteredPassword] = useState("")


  function getPiQrRadioVal(val) {
    setPiQrRadioVal(val)
  }
  const handleClose = () => {
    setPwdError(false)
    setEnteredPassword('')
    setPwdModalShow(false)
    if (pwdModalShow == false) {
        setEnteredPassword('')
    }
  };
  const [pwdError, setPwdError] = useState(false)
  
  const handlePwdChange = (e) => {
    setEnteredPassword(e.target.value);
    
      };


      const handleConfirmPwd = () => {
        const bytes = CryptoJS.AES.decrypt(localStorage.getItem("pwdid"), CRYPTO_SECRET_KEY);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        if (originalText === enteredPassword) {
          setPwdError(false)
    
          if (btnId === "closereview") {
            handlecloseReveiw()
          } else if (btnId === "sendBack") {
            sentBack()
          }
        } else {
          setPwdError(true)
        }
    
      }

  function handleReviewActions() {
    if (btnId === 'cancel') {
      setOpen(false)
    } else if (btnId === "sendBack") {
      setOpen(false)
      setPwdModalShow(true)
    } else if (btnId === 'closereview') {
      setOpen(false)
      setPwdModalShow(true)
      
    }
  }


  function handleClosePopup() {
    setOpen(false)
  }
  const[masterArray, setMasterArray] = useState([])
  
  const [existingWhoddIds,setExistingWhoddIds] = useState([])
  let finalIds = masterArray?.map(i => i.whodd_id);
  
  let uniqueIds = [...new Set(finalIds),...new Set(existingWhoddIds)];
  finalIds = Array.from(uniqueIds);
  let filteredIds = finalIds.filter(i => i)
  let commentObj = {
    "adverse_event_mapping_id": eventDtls?.adverse_event_mapping_id,
    "meddra_llt_master_id": (!meddraClassification)? null : (masterArray2[0]?.meddra_llt_master_id || eventDtls?.meddraObject?.meddra_llt_master_id),
    "meddra_mdhier_master_id": (!meddraClassification)? null : (masterArray2[0]?.meddra_mdhier_master_id || eventDtls?.meddraObject?.meddra_mdhier_master_id),
    "whodd_ids": filteredIds,
    "created_by": localStorage.login_user_name,
    "reviewer_id": localStorage.mr_id,
    "user_persona": MEDICAL_REVIEWER,
    "comment": reviewerComment,
  }


  function handlecloseReveiw() {
    
    if (eventDtls) {
      axios
        .post(base_url + "medical-reviewer/finish_review", commentObj)
        .then((res) => {
          setLoading(false)
          setPwdModalShow(false)
          setAlrtMessage("Review Success")
          setModalAlert(true)
         // window.location.reload();
        })
    }

  }
  const getMrData = useSelector((state) => state.mrStudyList);
  const [suggestionsWhodd, setSuggestionsWhodd] = useState([])
  const [dotsFlag1, setDotsFlag1] = useState(false)
  const [listFlag1, setListFlag1] = useState(false)

  function handleReviewBtns(e) {
    let id = e.target.id;
    setBtnId(id)
    dispatch(getPmsNotifications({
      user_id: localStorage.login_user_id,
      user_persona: MEDICAL_REVIEWER,
      study_id: getMrData?.map(item => item.study_id)
    }))
    if (id === 'sendBack') {
      setAlrtMessage("Are you sure you want to send back for correction?")
      setSendBackConfirmation(true)
      setOpen(true)
    } else if (id === 'closereview') {
      setSendBackConfirmation(false)
      setAlrtMessage("Are you sure you want to close the review?")
      setOpen(true)
    }
    else {
      setCurrentPage(1);
      dispatch(resetEventDetails())
      dispatch(resetSubjectProfile())   
      setReviewedDtls(false)
      window.location.reload()
    }
  }


  const handleOptionChange = (e, key, value) => {
    setStudyOption(value);
  };

  const [value, setValue] = useState("");
  const [value1, setValue1] = useState("");


  // const onChange = (event) => {

  //   if (event.target.value == "") {
  //     setInputValue({ llt: "", pt: "", soc: "", hlgt: "", hlt: "" })
  //     setIsMedraSelected(false)
  //     setSelectedMedraId("")
  //   }
  //   setValue(event.target.value);

  // };
  const [noRecordsFlag1 ,setNoRecordsFlag1] = useState(false)

  const fetchSuggestionsWhodd = async (searchQuery) => {
    axios
    .post(base_url + "whodd/fetch_drug_names_based_on_search_term",{"search_term":searchQuery})
    .then((response) => {
      
      setSuggestionsWhodd(response.data.data.productNames)
      setDotsFlag1(false)
      if(response.data.data.length===0 && searchQuery.length>2){
        setNoRecordsFlag1(true)
      }
      else{
        setNoRecordsFlag1(false)
      }
    })
  }

  const handleWhoDDClassification = (event, index) => {
    setEncodeBtn(false)
    setListFlag1(false)
    setDotsFlag1(false)
    setNoRecordsFlag1(false)
    const inputValue = event.target.value;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (inputValue.length > 2) {
        setEncodeBtn(true)
        setListFlag1(true)
        setDotsFlag1(true)
        fetchSuggestionsWhodd(inputValue);
      } else {
        setSuggestionsWhodd([]);
        setEncodeBtn(false)
        setListFlag1(false)
        setDotsFlag1(false)
        setNoRecordsFlag1(false)
      }
    }, 300);
    if(event.target.value.length >= 3){
      getAllWhoddClassificationNew(event.target.value)
    }
    medicationDetails.map((data) => {
      if (data.current_idx == index) {
        if (event.target.value == "") {
          data.whoDDEncode = true
          let fData = masterArray?.filter(i => i.index !== index)
          setMasterArray(fData)

          setIsBtn(false)
          data.whoddArray = []
          data.searchTerm = ''
          setMedicationDetails(medicationDetails)
          setEncodeBtn(false)

        } else {
          data.whoDDEncode = false
          setValue1(event.target.value);
          data.searchTerm = event.target.value
          setMedicationDetails(medicationDetails)
          setEncodeBtn(true)
        }

      }
    })

  };

  const onSearch = (sTerm, index) => {
    setListFlag(false)
    setValue(sTerm);
    meddraDetails.map((data, index1) => {
      if (data.current_idx == index) {
        data.searchTerm = sTerm
        data.medDRAEncode=true
        setMeddraDetails(meddraDetails)
        setEncodeMeddrabtn(false)
      }
    })
  };  


  const [encodeBtn, setEncodeBtn] = useState(true)
  const onSearch1 = (searchTerm, index) => {
    setValue1(searchTerm);
    setListFlag1(false)
    setDotsFlag1(true)
    setEncodeBtn(false)
    setSuggestionsWhodd([])
    let updatedData = [...masterArray]
    updatedData?.map((ele,i)=>{
    if(ele.index==index){
      updatedData.splice(i,1)
    }
  })
  setMasterArray(updatedData)
    medicationDetails.map((data, index1) => {
      // data.whoDDEncode = true;
      if (data.current_idx == index) {
        data.whoDDEncode = false
        data.whoddArray=[]
        data.searchTerm = searchTerm
        setMedicationDetails(medicationDetails)
      }
    })
    setSuggestionsWhodd([])
    };

    
  const handleDeleteFields =(index)=>{
    setIsBtn(true)
  let updatedData = [...medicationDetails]
    updatedData?.map((elemObj,i)=>{
    if(elemObj.current_idx==index){
      updatedData.splice(i,1)
    }
  })
  setMedicationDetails(updatedData)
  
  masterArray.map((ele, i) =>{
    if(ele.index == index){
  masterArray.splice(i, 1)
}
})
setMasterArray(masterArray)

}

  useEffect(() => {
    if (eventDtls) {
      setInputValue(eventDtls.meddraObject)
      setValue(eventDtls.meddraObject?.llt_name);
      // setSelectedMedraId(eventDtls.meddraObject?.meddra_classification_master_id)
      setExistingWhoddIds(eventDtls?.whoddDrugs?.map(i => i[0]?.whodd_id))
      setIsMedraSelected(true)
      setMasterArray(eventDtls?.whoddDrugs)


      eventDtls.whoddObjects?.map(item =>
        setSelectedCheckboxes((prevSelectedCheckboxes) => [...prevSelectedCheckboxes, item.whodd_id])
      )
      setWhoDDClassification(eventDtls.whoddDrugs)
      setMeddraClassification(eventDtls?.meddraObject)

    }

    if (eventDtls) {
      whoddList?.map((item, i) => {
        if (item.whodd_classification_master_id === eventDtls.whodd_classification_master_id) {
          setValue1(item.generic_name);
          setInputValue1(item)
        }
      });
    }



  }, [eventDtls?.adverse_event_mapping_id, eventDtls])

  const onEncode = (searchTerm) => {
    setValue(searchTerm);
    medraList?.map((item, i) => {
      if (item.llt_name === searchTerm) {
        setInputValue(item)
        setSelectedMedraId(item.meddra_classification_master_id)
        setIsMedraSelected(true)
      } else {

        return item.llt_name;
      }
    });

  }
const[whoddClassificationMasterId, setWhoddClassificationMasterId] = useState('')

  const [isBtn, setIsBtn] = useState(false)
  const [array, setArray] = useState([])
  const [loadFlag1, setLoadFlag1] = useState(false)

  const onEncode1 =(searchTerm,object)=>{
    setValue1(searchTerm);
    setListFlag1(false)
    setDotsFlag1(true)
    setLoadFlag1(true)
    axios
      .post(
        base_url + "whodd/fetch_complete_drug_details", {
        "drug_name": searchTerm
      }
      )
      .then((res) => {
        let whoddArray = res.data.data
        setLoadFlag1(false)
          setArray(whoddArray)
          medicationDetails.map((data, index) => {
            if (data.searchTerm != "" || data.searchTerm !==null) {
              setIsBtn(false)
            }
            else {
              setIsBtn(true)
            }
            if (data.current_idx == object.current_idx) {
              data.whoDDEncode = true
              medicationDetails[index].whoddArray = whoddArray;
              setMedicationDetails(medicationDetails)
              if (whoddArray?.length === 1) {

                setMasterArray((prev) => ([...prev, {
                  whodd_id: whoddArray[0].whodd_id,
                  index: object.current_idx,

                }]))

              } else {

                setMasterArray((prev) => ([...prev, {
                  whodd_id: null,
                  index: object.current_idx,

                }]))
              }
            }
          })
      })
  
  }

  const handleCheckboxChange = (event, checkboxId, index) => {
    setIsBtn(true)
    masterArray.map(i => {
      
      if (i.index == index) {
        i.whodd_id = checkboxId.whodd_id
      }
    })
    setMasterArray(masterArray)

    setWhoddClassificationMasterId(checkboxId.whodd_id)
    if (event.target.checked) {

      if (array?.length > 1) {
        setSelectedCheckboxes((prev) =>
          !prev.includes(checkboxId.whodd_id) ?
            [...prev, checkboxId.whodd_id] : prev
        )
      }
    } else {
      setSelectedCheckboxes((prevSelectedCheckboxes) =>
        prevSelectedCheckboxes.filter((id) => id !== checkboxId.whodd_id)
      );
    }
  };
  const handleDeleteFieldsWhoDD = (index) => {
    setIsBtn(true)
    let updatedData = [...medicationDetails]
    updatedData?.map((elemObj, i) => {
      if (elemObj.current_idx == index) {
        updatedData.splice(i, 1)
      }
    })
    setMedicationDetails(updatedData)

    masterArray.map((ele, i) => {
      if (ele.index == index) {
        masterArray.splice(i, 1)
      }
    })
    setMasterArray(masterArray)
  }

  const handleDelete = (event) => {
    let updatedData = [...whoDDClassification]

   updatedData?.map((elemObj,i)=>{
     if(elemObj.whodd_id===event){
       updatedData.splice(i, 1)
     }
   })
   setWhoDDClassification(updatedData)


   setSelectedCheckboxes((prevSelectedCheckboxes) =>
     prevSelectedCheckboxes.filter((id) => id !== event)
   );

   let newArray = masterArray.filter(obj => obj.whodd_id !== event)
   setMasterArray(newArray);
 };

 


  function handleWHODD(e) {
    const { name, value } = e.target;

    setWhoddBlock((prev => ({
      ...prev,
      [name]: value,
    })))
  }

  const handleAscending = () => {
    setAsC(true);
    setDesc(false);
  
    const sortedData = [...filteredData];
  
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
  
      return subjectCodeA.localeCompare(subjectCodeB);
    });
  
    setFilteredData(sortedData);
  };
  
  const handleDescending = () => {
    setDesc(true);
    setAsC(false);
  
    const sortedData = [...filteredData];
  
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeB.localeCompare(subjectCodeA);
    });
  
    setFilteredData(sortedData);
  };
  

  const handleAddFields = () => {
    setIsBtn(false)

    setMedicationDetails([...medicationDetails,
    {
      "ATC": "",
      "searchTerm": "",
      "Product": "",
      "whoDDEncode":true,
      "current_idx": currentIndex + 1
    },]);
    setValue1("")
    setCurrentIndex(currentIndex + 1);
  };
  const cleanText =
    eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI ? eventDtls?.input_notes_aesi_others :
      eventDtls?.study_case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? eventDtls.study_event_meets_case_definition || eventDtls.study_event_doesnt_meets_case_definition :
        eventDtls?.study_case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE ? eventDtls.study_ctcae_definition :
          eventDtls?.study_case_definition === EVENT_CLASSIFICATION_OTHER ? eventDtls?.input_notes_aesi_others : '';

  const handleViewClick = (document) => {
    setSelectedDocument(document);
  };
  function getIcon(fileExtension) {
    switch (fileExtension) {
      case 'pdf':
        return "./images/icons/reshot-icon-pdf.svg"
      case 'ppt':
        return "./images/icons/reshot-icon-ppt.svg"
      case 'txt':
        return "./images/icons/reshot-icon-txt.svg"
      case 'docx':
        return "./images/icons/reshot-icon-docx.svg"
      case 'doc':
        return "./images/icons/reshot-icon-doc.svg"
      case 'xls':
        return "./images/icons/reshot-icon-xls.svg"
      case 'csv':
        return "./images/icons/reshot-icon-csv.svg"
      case 'jpg':
        return "./images/icons/reshot-icon-jpg.svg"
      case 'png':
        return "./images/icons/reshot-icon-png.svg"
      case 'jpeg':
        return "./images/icons/reshot-icon-jpeg.svg"
     }
  }
  const handleOpenModal = (document) => {
    setSelectedDocument(document);
  };

  const handleCloseModal = () => {
    setSelectedDocument(null);
  };
  const isImage = (url) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    return imageExtensions.includes(url);
  };

  const [meddraDetails, setMeddraDetails] = useState([
    {
      "searchTerm": "",
      "current_idx": 0,
      "checkedMeddra":"",
      "medDRAEncode": false,
      "meddraArray": [],
    },
  ]);

  const [encodeMeddrabtn, setEncodeMeddrabtn] = useState(true);
 
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  let debounceTimer;
  const [listFlag, setListFlag] = useState(false)
  const [dotsFlag, setDotsFlag] = useState(false)
  const [loadFlag, setLoadFlag] = useState(false)

  function handleNoModalAlert() {
    setModalAlert(false)
  }
  const handleMeddraClassification1 = (event, index) => {
    setListFlag(true)
    setDotsFlag(true)
    setNoRecordsFlag(false)
    const inputValue = event.target.value;
    setQuery(inputValue);
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (inputValue.length > 0) {
        fetchSuggestions(inputValue);
      } else {
        setSuggestions([]);
      }
    }, 300); 
    meddraDetails.map(data => {
      if (data.current_idx == index) {
        if (event.target.value == "") {
          setNoRecordsFlag(false)
          setDotsFlag(false)
          setListFlag(false)
          data.meddraArray = []
          setValue("")
          data.searchTerm = ''
          setEncodeMeddrabtn(true)
          data.medDRAEncode =true
          setMeddraDetails(meddraDetails)
          
        } else {
          setValue(event.target.value);
          data.medDRAEncode =false
          data.searchTerm = event.target.value
          setEncodeMeddrabtn(true)
          setMeddraDetails(meddraDetails)
        }
      }
    })
  };
  const handleModalSave =()=>{
    setModalAlert(false)
   window.location.reload();
  }


const handleDeleteMeddra=()=>{
  setMeddraClassification()
}
const handleRadioChange = (selectedValue) => {
  setSelectedOption(selectedValue);
  if (selectedValue === 'serious_adverse_events') {
    setFilteredData(mrSubjectList.filter(i => i.serious_adverse_event_id !== null))
  } else if (selectedValue === 'adverse_events') {
    setFilteredData(mrSubjectList.filter(i => i.adverse_event_id !== null))
  } else if(selectedValue === 'subject_with_pending'){
    setFilteredData(mrSubjectList.filter(i => i.status === 0 || i.status===1))
  }else if (selectedValue === 'all_events') {
    setFilteredData(mrSubjectList)
  }
};
const [selectedOption, setSelectedOption] = useState(getEventFlag?.option); 

  const[noRecordsFlag, setNoRecordsFlag] = useState(false)
  
  const fetchSuggestions = async (searchQuery) => {
    axios
    .post(base_url + "meddra-master/fetch_all_llt_names_based_on_search_term",{"llt_name":searchQuery})
    .then((response) => {
    setSuggestions(response.data.data)
    setDotsFlag(false)
    if(response.data.data.length===0){
      setNoRecordsFlag(true)
    }
    })
  }
  const onEncode2 = (searchTerm, object) => {
    setLoadFlag(true)
    setMedView(false)
    setValue(searchTerm);
    axios
      .post(
        base_url + "meddra-master/fetch_llt_occurences", {
        "llt_name": searchTerm
      }
      )
      .then((res) => {
        let meddraArray = res.data.data
        setLoadFlag(false)
    meddraDetails.map((data, index) => {
      if (data.searchTerm != "" || data.searchTerm !=null) {
        setIsBtn(true)
      }
      else {
        setIsBtn(false)
      }
      if (data.current_idx == object.current_idx) {
        data.medDRAEncode = true
        data.checkedMeddra = ""
        meddraDetails[index].meddraArray = meddraArray;
        setMeddraDetails(meddraDetails)
        if (meddraDetails?.length === 1) {

          setMasterArray2((prev) => ([...prev, {
            meddra_llt_master_id: meddraArray[0]?.meddra_llt_master_id,
            index: object.current_idx,
            meddra_mdhier_master_id: meddraArray[0]?.meddra_mdhier_master_id,

          }]))

        } else {

          setMasterArray2((prev) => ([...prev, {
            meddra_llt_master_id: null,
            index: object.current_idx,
            meddra_mdhier_master_id: null

          }]))
        }



      }
    })

  })


  }
  return (
    <>
      <div>
      <PasswordModal pwdError={pwdError} handleConfirmPwd={handleConfirmPwd} handlePwdChange={handlePwdChange} enteredPassword={enteredPassword} pwdModalShow={pwdModalShow} handleClose={handleClose}/>
        <NavigationBar
          studyDropdwn={studyDropdwn}
          title={"Event Review List"}
          rolecode={getRoleCode}
          handleOptionChange={handleOptionChange}
          handleFilteredData={handleStudyChange}
          getStudieId={getStudieId}
        />
        {/* <MedicalReviewerFlow /> */}
        <PopUpModal
                handleClose={handleClosePopup}
                open={open1}
                title={"Success!"}
                msg={"Event has already been attended to!"}
                close={"Close"}
                actionbtn={"Done"}
                onConfirm={alreadyAttended}
              />
        <PopUpModal
          handleClose={handleNoModalAlert}
          open={modalAlert}
          title={"Success!"}
          msg={alertMessage}
          close={""}
          actionbtn={'Done'}
          onConfirm={handleModalSave}
        />     
        <div className="main_body ">
          {currentPage === 1 && (
            <Container fluid className="py-4 ">
              <Stack className="add_subject_stack px-0">
                <div className="">
                  <Row className="row d-flex">
                    {dashboardCards?.map((card, index) => {
                      return (
                        <Col key={index}>
                          <div
                            className="card-container C-pointer"
                            style={{ backgroundColor: card.bgcolor, outline: selectedOption === card.id ? "2px solid black" :"" }}
                            onClick={() => handleRadioChange(card.id)}
                          >
                            <div
                              className="content"
                              style={{ color: card.textColor }}
                            >
                              <span>{card.count}</span>
                              <img src={card.image} alt="" />
                            </div>
                            <div
                              className="desc"
                              style={{ color: card.textColor }}
                            >
                              {card.desc}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              </Stack>

              {mrSubjectList && mrSubjectList?.length > 0 ? (
                <Container fluid className="pitable_container mt-4  ">
                  <Row className='searchbar'>
                    <Col className='searchFiled gap-3'>
                      <label htmlFor="" />
                      <input type="text" value={searchText} style={{ width: "400px" }} placeholder='Search with Subject ID or Site Name' onChange={handleSearchData} />
                      <div className=" ">
                        <button
                            className="btn btn-success "
                            style={{height:"42px"}}
                          onClick={exportToExcel}
                        >
                          Download XLS
                          <img src="./images/icons/download.svg" alt="#" style={{marginLeft:"5px"}}/>
                        </button>
                      </div>

                    </Col>
                  </Row>

                  <div>
                    {loading_flag ? (
                      <div className=''>
                        <img
                          className="atrium_loader"
                          src="/images/circle-effect-loading.gif"
                          alt="Loader"

       />
     </div>
        
      ) : (
        <div className="table-scroll-container " style={{border:"1px solid #E1E5E7 "}}>
        {filteredData?.length > 0 ?
          <Table bordered size="sm" className="pitable mb-0">
            <thead className="sticky_table_header">
              <tr>
                <th> S.No</th>
                <th className="sticky-header">
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                          <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"40%" }}>Subject ID</span>
                            <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                              <g id="icon_sort">
                                <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                              </g>
                            </svg>
                            </div>
                        </th>
                <th style={{ minWidth: "145px" }}>
                  Adverse Events
                </th>
                <th>
                  Serious Adverse Criteria
                </th>
                <th>
                  Date of upload
                </th>
                <th style={{ minWidth: "70px" }}>
                  Site Name
                </th>
                {/* <th style={{minWidth:"90px"}}>Location
          
                          </th> */}

                                <th>Status</th>
                              </tr>
                            </thead>

            <tbody className="tableBodyScroll">
              {filteredData?.map((i, index) => {
                let formatedDate=formatDateNoTime(i.event_createdAt)
                return (
                  <tr key={i.index} className="text_left_table">
                    <td className="text_right_sno"> {index + 1} </td>
                    <td>{i.subject_code? i.subject_code:"-"}</td> 
                    <td>{i.adverse_event_name? i.adverse_event_name:"-"}</td>
                    <td>{i.serious_adverse_event_name? i.serious_adverse_event_name:"-"}</td>
                    <td className="text-center">{formatedDate}</td>
                    <td>{i.site_name? i.site_name:"-"}</td>

                                    <td className="viewbtnstyles">
                                      {i.status ===
                                        EVENT_STATUS_WAITING_FOR_REVIEW ? (
                                          <button
                                            className="gray_btn py-1"
                                            onClick={() => handleSubjectData(i)}
                                          >
                                            Waiting for review
                                          </button>
                                        ):
                                      i.status === EVENT_STATUS_IN_PROGRESS ? (
                                        <button
                                          className="orange_btn py-1"
                                          onClick={() => handleSubjectData(i)}
                                        >
                                          In progress
                                        </button>
                                      ):
                                      i.status === EVENT_STATUS_REVIEWED ?(
                                        <button
                                          className="green_btn py-1"
                                          onClick={() => handleSubjectData(i)}
                                        >
                                          Reviewed
                                        </button>
                                      ):
                                      i.status ===
                                        EVENT_STATUS_SENT_BACK_FOR_REVIEW ? (
                                          <button
                                            className="red_btn py-1"
                                            disabled

                                          >
                                            Sent Back For Review
                                          </button>
                                        ):"-"}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                          :
                          <div className="bg-white border py-4 text-center">No records found with search criteria</div>

                        }
                      </div>
                    )}
                  </div>

                </Container>
              ) : mrSubjectList === null && localStorage.study_id ? <div className=''>
              <img
                  className="atrium_loader"
                  src="/images/circle-effect-loading.gif"
                  alt="Loader"

              />
            </div> : (
                <>


                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '5rem' }}>
                    <img src="./images/no_subjects.svg" alt="Telephone" />
                    <h5> No events found </h5>
                  </div>
                </>
              )}
            </Container>
          )}

          {currentPage === 2 && subjDetails && eventDtls && subjectProfile &&  (
            <Container fluid className="p-3 page_two_styl ">
              <Row className="SVdtl_Main">
                <Col lg={4} className="section_1">


                  {subjDetails && <div className="pisubj_left_main">
                    <div className="review_min_high">
                      <div className="body_cls pb-2">


                        <span>

                          <h6 className="mt-3">{subjDetails?.subject_code}</h6></span>

                                                 <div className="row">
                          <div className="col-6 p-0">
                            <div className="mb-0">
                              <span className="mb-0" style={{padding:"0px"}}>Age:</span> <span className="space_yrs highlet-left">{subjectProfile?.age} Yrs</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="mb-0">
                              <span className="mb-0">Height:</span> <span className='space_height highlet-left'>{subjectProfile?.height ? subjectProfile.height : 0} cm</span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 p-0">
                            <div className="mb-0">
                              <span className="mb-0">Gender:</span> <span className='highlet-left'>{subjDetails?.sex}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="mb-0">
                              <span className="mb-0">Weight:</span> <span className='highlet-left'>{subjectProfile?.weight}Kg</span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 p-0">
                            <div className="mb-0">
                              <span className="mb-0">BMI:</span> <span className="space_bmi highlet-left">{calculateBMI(subjectProfile?.weight, subjectProfile?.height)} (BMI)</span>
                            </div>
                          </div>
                          </div>
                        
                        <span className="d-flex justify-content-between w-100">

                          <h6 className="site_add">
                            {subjDetails['Site.site_address']}
                          </h6>
                          <img
                            className=""
                            src="./images/icons/location.svg"
                            alt="Location Icon"
                          />
                        </span>
                      </div>
                      <div className="px-3 s2">
                        {myArray.map((i, index) => {
                          return (
                            <div className="studytab" key={index}>
                              <span className="text-start">{i.title}</span>
                              <span className="study_tab_desc">
                                {i.description}
                              </span>
                            </div>
                          );
                        })}
                      </div>

                      <div className="px-3 s2">
                        {reviewerComments && reviewerComments?.filter(i => i.user_persona === QUALITY_REVIEWER).length > 0 &&
                          <div className="studytab">
                            <span className="text-start">
                              Quality Reviewer Comments
                            </span>
                            {reviewerComments && reviewerComments?.filter(
                              i => i.user_persona === QUALITY_REVIEWER
                            ).map((i, index) => {
                              return (
                                <div key={index}>

                                  <div className="qr_cmts_txt d-flex flex-row">
                                    <li></li>
                                    <div>{i.comment}</div>
                                  </div>
                                  <span className="qr_cmts_date ">
                                    By : {i.created_by} {", "} On :{" "}
                                    {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                  </span>
                                </div>

                              );
                            })
                            }
                          </div>}



                        {reviewerComments && reviewerComments?.filter(i => i.user_persona === MEDICAL_REVIEWER).length > 0 &&
                          <div className="studytab">

                            <span className="text-start">
                              Medical Reviewer Comments
                            </span>
                            {reviewerComments && reviewerComments?.filter(
                              i => i.user_persona === MEDICAL_REVIEWER
                            ).map((i, index) => {
                              return (
                                <div key={index}>

                                  <div className="qr_cmts_txt d-flex flex-row">
                                    <li></li>
                                    <div>{i.comment}</div>
                                  </div>
                                  <span className="qr_cmts_date ">
                                    By : {i.created_by} {", "} On :{" "}
                                    {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                  </span>
                                </div>

                              );
                            })

                            }
                          </div>
                        }
                      </div>


                    </div>
                  </div>}
                </Col>
                <div className="col review_event_header pisub">
                  <div className='title_cls right_cntnt'>
                    <h5 className="mb-1">Events</h5>
                    {/* <span >1 of 2</span> */}
                  </div>

                  <Col className="px-4 py-3 qr_right_content">
                    <div className="d-flex justify-content-between ">

                      <div className="">
                        <label htmlFor="dateOfonSet" className="custm_label_fw">
                          Date of onset
                        </label>
                        <input
                          value={eventDtls?.date_of_onset}
                          className="customInput"
                          id="dateOfonSet"
                          type="date"
                          placeholder="Enter Here"
                          disabled
                          aria-placeholder="#D4D4D4"
                          style={{
                            padding: "16px 12px",
                            width: "340px",
                            cursor: "not-allowed",
                          }}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>

                      <div className="">
                        <label htmlFor="timeOfonSet" className="custm_label_fw">
                          Time of onset (24 Hrs)
                        </label>
                        <input
                          value={eventDtls?.time_of_onset}
                          className="customInput"
                          disabled
                          id="timeOfonSet"
                          type="time"
                          placeholder="Enter Here"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between ">
                      <div className="">
                        <label
                          htmlFor="dateOfResolution"
                          className="custm_label_fw"
                        >
                          Date of resolution
                        </label>
                        <input
                          value={eventDtls?.date_of_resolution}
                          // value={moment(eventDtls?.date_of_resolution).format("DD-MM-YYYY")}
                          disabled
                          className="customInput"
                          id="dateOfResolution"
                          // min={minDate}
                          type="date"
                          placeholder="Enter Here"
                          aria-placeholder="#D4D4D4"
                          style={{
                            padding: "16px 12px",
                            width: "340px",
                            cursor: "not-allowed",
                          }}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>

                      <div className="">
                        <label htmlFor="lastName" className="custm_label_fw">
                          Time of resolution (24 Hrs)
                        </label>
                        <input
                          value={eventDtls?.time_of_resolution}
                          disabled
                          className="customInput"
                          id="lastName"
                          type="time"
                          placeholder="Enter Here"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                    </div>

                    <div htmlFor="lastName" className="custm_label_fw">
                      Past Health History
                    </div>
                    <div className="d-flex justify-content-between">
                      <div>
                        <label htmlFor="lastName" className="">
                          Allergies
                        </label>
                        <input
                          value={eventDtls?.allergies ? eventDtls.allergies : '-'}
                          disabled
                          className="customInput"
                          id="lastName"
                          type="text"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                      <div>
                        <label htmlFor="medical_history" className="">
                          Medical history
                        </label>
                        <input
                          value={eventDtls?.medical_history ? eventDtls.medical_history : '-'}
                          disabled
                          className="customInput"
                          id="medical_history"
                          type="text"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                    </div>

                    <div className="d-flex justify-content-between">
                      <div>
                        <label htmlFor="lastName" className="">
                          Concurrent Illness
                        </label>
                        <input
                          value={eventDtls?.concurrent_illness ? eventDtls.concurrent_illness : '-'}
                          disabled
                          className="customInput"
                          id="lastName"
                          type="text"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                    
                    </div>

                    {eventDtls?.serious_adverse_event_name &&
                      <Row className="d-flex align-items-center">

                        <Col>
                          <label htmlFor="lastName" className="custm_label_fw">
                            Serious adverse event criteria
                          </label>
                        </Col>
                        <Col>
                          <span>
                            <button className="red_btn advesre-serious"> {eventDtls?.serious_adverse_event_name}</button>
                          </span>
                        </Col>
                      </Row>
                    }
                    {eventDtls?.study_aebank_event_title !== null && <Row className="d-flex align-items-center">
                      <Col>
                        <label htmlFor="lastName" className="custm_label_fw">
                          Adverse event
                        </label>
                      </Col>
                      <Col>
                        <span>
                          <button className="orange_btn advesre-serious" > {eventDtls?.study_aebank_event_title}</button>
                        </span>
                      </Col>
                    </Row>}
                    <div className="advEventGroup">
                      <div className="p-4 bg-light rounded eventClassificationDiv">
                        <div className="custm-radio-styl reviewlist">
                          <div className="reviewaetilte">
                            <label
                              htmlFor="notmetcase"
                              style={{
                                display: "flex",
                                alignItems: "start",

                              }}
                            >
                              <input
                                type="radio"
                                id="notmetcase"
                                checked
                                style={{ width: "20px" }}
                              />
                              <span
                                style={{ marginLeft: "10px" }}
                              >
                                <div className="custm-radio-styl ">
                                  {eventDtls?.study_event_meets_case_definition !== null ?
                                    "Event meet case definition" :
                                    eventDtls?.study_event_doesnt_meets_case_definition !== null ?
                                      "Event does not meet case definition" :
                                      eventDtls?.study_ctcae_definition !== null ?
                                        "Grade" :
                                        eventDtls?.study_aebank_event_title && eventDtls?.study_case_definition == EVENT_CLASSIFICATION_AESI ? 'Adverse Event of Special Interest' : 'Other'
                                  }
                                </div>
                              </span>
                            </label>
                          </div>

                          <div className="subtext">
                            <img src="./images/icons/checkedbox.svg" alt="" />
                            <span>{cleanText}</span>
                          </div>
                        </div>
                      </div>
                    </div>



                    <div className={` gap-2 border p-3 rounded`}>
                      <div className="d-flex flex-column gap-3">
                        <div className={`d-flex ${JustBtwn}`}>
                          <div className="">
                            <label htmlFor="causality">
                              Causality
                            </label>
                            <input
                              value={eventDtls?.causality_name}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>
                          <div className="">
                            <label htmlFor="outCome">
                              Outcome
                            </label>
                            <input
                              value={eventDtls?.outcome_name}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>

                        </div>
                        <div className={`d-flex ${JustBtwn}`}>
                          <div className="">
                            <label htmlFor="actionTaken">
                              Action Taken For Study Vaccine
                            </label>
                            <input
                              value={eventDtls?.action_taken_name}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>
                          <div className="">
                            <label htmlFor="actionTaken">
                              Action Taken For Adverse Event
                            </label>
                            <input
                              value={eventDtls?.action_taken_for_adverse_event_name}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />

                          </div>

                        </div>
                        <div className="d-flex justify-content-between ">
                          {flag && (
                            <div className="">
                              <label htmlFor="startDate" className="custm_label_fw">
                                <p className="adverse-auto">Treatment Start Date</p>
                              </label>
                              <input
                                value={eventDtls?.start_date_of_treatment}
                                className="custminputbml selectTag"
                                id="start_date_of_treatment"
                                type="date"
                                disabled
                                placeholder="Enter Start Date"
                                aria-placeholder="#D4D4D4"
                                style={{ padding: "16px 12px", width: "340px" }}

                              />
                            </div>
                          )}
                          {/* End Date input */}
                          {flag && (
                            <div className="">
                              <label htmlFor="endDate" className="custm_label_fw">
                                <p className="adverse-auto">Treatment End Date</p>
                              </label>
                              <input
                                value={eventDtls?.end_date_of_treatment}
                                className="custminputbml selectTag"
                                id="end_date_of_treatment"
                                type="date"
                                disabled
                                placeholder="Enter End Date"
                                aria-placeholder="#D4D4D4"
                                style={{ padding: "16px 12px", width: "340px" }}

                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>


                    {reviewerComments && reviewerComments?.filter(i => i.user_persona === PRINCIPAL_INVESTIGATOR).length > 0 &&
                      <div>
                        <label htmlFor="Treatment" className="fw-bold fs-6">Treatment Given</label>
                        <div
                          className="border py-3 px-2 rounded w-100"

                        >
                          {
                            reviewerComments && reviewerComments?.map((i, index) => {
                              return (
                                i.user_persona === PRINCIPAL_INVESTIGATOR ?
                                  <div className="d-flexflex-column">
                                    <div className="d-flex">
                                      <li></li>
                                      <div>{i.comment.charAt(0).toUpperCase() + i.comment.slice(1)}</div>
                                    </div>
                                    <p className=" updateae_cmnt_date">
                                      Treated On: {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                    </p>
                                  </div>
                                  : "")
                            })
                          }
                        </div>
                      </div>
                    }
                                                       <div>
  {selectedDocument && !['xlsx', 'xls'].includes(extensions) && (
    <Modal show={selectedDocument !== null} onHide={handleCloseModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isImage(extensions) ? (
          <img
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc', width: "100%" }}
          />
        ) : (
          <iframe
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc' }}
          />
        )}
      </Modal.Body>
    </Modal>
  )}
</div>

                    <MeddraDetails
                    handleDeleteMeddra={handleDeleteMeddra}
                    noRecordsFlag={noRecordsFlag}
                    dotsFlag={dotsFlag}
                    loadFlag={loadFlag}
                    listFlag={listFlag}
                      meddraDetails={meddraDetails}
                      handleMeddraClassification1={handleMeddraClassification1}
                      encodeMeddrabtn={encodeMeddrabtn}
                      value={value}
                      inputValue={inputValue}
                      handleCheckboxChange2={handleCheckboxChange2}
                      reviewedDtls={reviewedDtls}
                      medView={medView}
                      meddraClassification={meddraClassification}
                      onEncode2={onEncode2}
                      suggestions={suggestions}
                      onSearch={onSearch} />




                <MedicationDetails 
                  noRecordsFlag1={noRecordsFlag1}
                  masterArray = {masterArray}
                  handleDeleteFieldsWhoDD={handleDeleteFieldsWhoDD}
                  encodeBtn = {encodeBtn}
                  medicationDetails={medicationDetails}
                  whoddList={whoddList}
                  listFlag1={listFlag1}
                  dotsFlag1={dotsFlag1}
                  loadFlag1={loadFlag1}
                  suggestionsWhodd = {suggestionsWhodd}
                  handleDeleteFields= {handleDeleteFields}
                  reviewedDtls={reviewedDtls}
                  handleWhoddFunction={handleWhoDDClassification}
                  onEncode1={onEncode1}
                  value1={value1}
                  onSearch1={onSearch1}
                  whoddClassificationMasterId={whoddClassificationMasterId}
                  handleCheckboxChange={handleCheckboxChange}
                  handleWHODD={handleWHODD}
                  whoDDClassification={whoDDClassification}
                  handleDelete={handleDelete}/>


               {!reviewedDtls &&<div className="addBtn">
                      <button
                        className="white_btn px-2"
                        onClick={handleAddFields}
                        disabled={!isBtn}
                      >
                        Add More
                      </button>
                </div>}

                    <div className={JustBtwn}>
                      {subjData.status !== EVENT_STATUS_REVIEWED && <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "20px",
                          width: "100%",
                          alignItems: "start",
                        }}
                      >
                        <label htmlFor="add your comments" className="fw-bold fs-6">
                          Add your comments<span className="text-danger">*</span>
                        </label>
                        <textarea
                          id="add_your_comments"
                          style={{
                            width: "100%",
                            minHeight: "100px",
                            borderColor: "#E1E5E7",
                            borderRadius: "8px",
                            padding: "10px"
                          }}
                          placeholder="type here"
                          onChange={handleReviewerComments}
                        />
                      </div>}
                    </div>
                  </Col>
                </div>

                <div className="registrationStepsFooter" >
                  {subjData.status === EVENT_STATUS_REVIEWED ?
                    <button className="white_btn white_btn_back px-3" onClick={() => {
                      setCurrentPage(1);
                      setStudyDropdwn(false);
                      window.location.reload()
                    }}>
                      Back
                    </button>
                    : <div className="d-flex gap-2">
                      <button className="white_btn white_btn_back px-3" id={'cancel'} onClick={handleReviewBtns}>
                        Back
                      </button>
                      <button
                        id={'sendBack'}
                        className="red_btn"
                        onClick={handleReviewBtns}
                        disabled={reviewerComment === ''}
                      >
                        Send Back for Correction
                      </button>

                      <button
                        id={'closereview'}
                        className="green_btn"
                        onClick={handleReviewBtns}
                        // disabled={!(closeReviewBtn && cmtbtnStat && closereviewWhodd)}
                        disabled={!(cmtbtnStat && medraSelected)}

                      >
                        Close Review
                      </button>
                    </div>}
                </div>
              </Row>
            </Container>
          )}
        </div>


        <PopUpAlert
          handleClose={handleClosePopup}
          open={open}
          // title={"?"}
          msg={<span className="lower">{alertMessage}</span>}
          sendBackConfirmation={sendBackConfirmation}
          getPiQrRadioVal={getPiQrRadioVal}
          close={"Cancel"}
          actionbtn={'Sure'}
          onConfirm={handleReviewActions}
        />
      </div>
      {loading && <Loader />}
    </>

  );
};

export default MedicalReviewerReviewList;
